import Storage from '@/handler/storageLocal'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'

const APP_BUILD_VERSION_KEY = 'AppBuildVersion'
const APP_BUILD_RELOAD_KEY = 'AppBuildVersionReload'

async function clearServiceWorkerAndCaches() {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map((registration) => registration.unregister()))
    }
  } catch (error) {}

  try {
    if ('caches' in window) {
      const cacheKeys = await caches.keys()
      await Promise.all(cacheKeys.map((key) => caches.delete(key)))
    }
  } catch (error) {}
}

function checkAppBuildVersion() {
  fetch('/version.json?_=' + Date.now(), { cache: 'no-store' })
    .then((response) => (response.ok ? response.json() : null))
    .then(async (data) => {
      if (!data || !data.buildId) return

      const remoteBuildId = data.buildId.toString()
      const currentBuildId = Storage.getValue(APP_BUILD_VERSION_KEY)

      if (currentBuildId && currentBuildId !== remoteBuildId) {
        const reloadedBuildId = sessionStorage.getItem(APP_BUILD_RELOAD_KEY)
        if (reloadedBuildId !== remoteBuildId) {
          sessionStorage.setItem(APP_BUILD_RELOAD_KEY, remoteBuildId)
          await clearServiceWorkerAndCaches()

          const currentUrl = new URL(window.location.href)
          currentUrl.searchParams.set('_v', remoteBuildId)
          window.location.replace(currentUrl.toString())
          return
        }
      }

      Storage.setValue(APP_BUILD_VERSION_KEY, remoteBuildId)
      if (sessionStorage.getItem(APP_BUILD_RELOAD_KEY) === remoteBuildId) {
        sessionStorage.removeItem(APP_BUILD_RELOAD_KEY)
      }
    })
    .catch(() => {})
}

window.__checkAppVersion = checkAppBuildVersion
checkAppBuildVersion()

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(() => {
      console.log("Service Worker Registered!")

      navigator.serviceWorker.addEventListener('message', event => {
        if (event.data && event.data.type === 'SW_ACTIVATED') {
          window.dispatchEvent(new CustomEvent('sw-activated'))
        }
      })

      try {
        if (Storage.getValue('ConfigurationNotificationsPush')) {
          require("./handler/notifications.js")
        } else {
          Vue.use(VueAxios, axios)
          const instance = axios.create()
          instance.get(ConfigAPI.baseURL + "public/notifications/push/1/configuration")
            .then((res) => {
              Storage.setValue('ConfigurationNotificationsPush', JSON.stringify(res.data))
              try { require("./handler/notifications.js") } catch(e) { /* firebase no disponible */ }
            })
            .catch(() => {})
        }
      } catch(e) {
        // Firebase no disponible (sin conexión o CDN no cargó)
      }
    })
    .catch(err => console.warn("Service Worker no disponible:", err))
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './app'
import router from './router'
import VueAWN from "vue-awesome-notifications"
import Loading from 'vue-loading-overlay';
import moment from 'moment'
import excel from 'vue-excel-export'
import VueLazyload from 'vue-lazyload'
import Session from '@/handler/session'
import vSelect from 'vue-select'

// Select2
Vue.component('v-select', vSelect)
// End select2
 
// todo
// cssVars()

// Color Principal
var primaryColor = 'black'
if(Session.getSession().settings) {
  primaryColor = Session.getSession().settings.color_primary
}
// End color Principal

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(VueAWN,{
  maxNotifications: 1
});

Vue.use(Loading,{
    //container: this.$refs.loadingContainer,
    color: primaryColor,
    loader: 'spinner',
    width: 128,
    height: 128,
    backgroundColor: '#ffffff',
    opacity: 0.3,
})
Vue.use(excel)
Vue.use(VueLazyload)

moment.locale('es')
Vue.prototype.moment = moment

/* eslint-disable no-new */
var VueApp =  new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
